import * as hooks from './hooks';

export const useSetupCookiesGroups = () => {
    hooks.useSetCommonCookie();
    hooks.useSetInitialCookiesGroups();
    hooks.useRemoveCookies();
};
